export default __webpack_public_path__ + "static/media/landing-page-customer-register.960388ae.svg";